import axios from 'axios';
import URL from '../constants/Url';
import NewsLetterActions from '../actions/NewsLettersActions';

const NewsLetterSource = {

    getSubscriptionStatus: {
        remote(state, data) {
            return axios.get(URL().GET_SUBSCRIPTION_STATUS, {
                params: {email: data.email}
            });
        },
        success: NewsLetterActions.getSubscriptionStatusSuccess,
        error: NewsLetterActions.getSubscriptionStatusFailure
    },

    signUpNewsLetter: {
        remote(state, data) {
            return axios.post(URL().SIGN_UP_NEWS_LETTER, {
                email: data.email
            });
        },
        success: NewsLetterActions.signUpNewsLetterSuccess,
        error: NewsLetterActions.signUpNewsLetterFailure
    }

};

export default NewsLetterSource;



// WEBPACK FOOTER //
// ./app/scripts/sources/NewsLetterSource.js